import Vue from 'vue'
import Vuex from 'vuex'
import {BootstrapVue, IconsPlugin, VBToggle, VBModal} from 'bootstrap-vue'
import Chart from 'chart.js'
import Chartkick from 'vue-chartkick'
import VueCookies from 'vue-cookies'
import VueGoodTablePlugin from 'vue-good-table'
import VuePapaParse from 'vue-papa-parse'
import VueRouter from 'vue-router'
import Snotify, {SnotifyPosition} from 'vue-snotify'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueTour from 'vue-tour'
import VueTreeList from 'vue-tree-list'
import VueFormWizard from 'vue-form-wizard'

const SnotifyOptions = {
    toast: {
        position: SnotifyPosition.rightTop
    }
}

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: 'places',
    },
})
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.directive('b-toggle', VBToggle)
Vue.directive('b-modal', VBModal)
Vue.use(VueRouter)
Vue.use(VueTour)
Vue.use(VueGoodTablePlugin)
Vue.use(Snotify, SnotifyOptions)
Vue.use(Chartkick.use(Chart))
Vue.use(VueCookies)
Vue.use(VuePapaParse)
Vue.use(VueTreeList)
Vue.use(VueFormWizard)

VueCookies.set('language', 'JavaScript')
